<!--设备marker-->
<template>
  <div class="sb_marker">
    <div style="width: 100%;height: 100%; text-align: center">
      <span>{{ data_p.sbmc || '' }}</span>
    </div>

    <div class="sb_marker_item">
      <span>设备编号：<span title="详情" @click="do_sbbh" style="color: #00ffff;cursor: pointer" >{{ data_p.sbbh || '' }}</span></span>
    </div>

    <div class="sb_marker_item">
      <span>所属单位：<span>{{ data_p.ssdw || '' }}</span></span>
    </div>

    <div class="sb_marker_item">
      <span>所在地区：<span>{{ data_p.szdq || '' }}</span></span>
    </div>

    <div class="sb_marker_item">
      <span>设备状态：<span>{{ data_p.sbzt || '' }}</span></span>
    </div>
  </div>
</template>

<script>
import api_home from "../../api/api_home_page";

export default {
  name: "shebei_marker",
  data() {
    return {
      data_p: {
        sbbh:'',
        sbmc: '',
        ssdw: "",
        szdq: "",
        sbzt: ''
      }
    }
  },
  created(){

  },
  methods:{

    async do_sbbh() {
      let that = this
      try {

        let res = await api_home.getDeviceInfo({"number": this.data_p.sbbh});

        if (res.code == 200) {
          res.data = res.data || {}
          this.$bus.emit('sys_show_sb_detail',res.data)
        } else {
          this.GLOBAL.common_tool.warning(res.msg || '查询设备详情错误')
        }
      } catch (e) {
        that.GLOBAL.common_tool.sys_reason_log('查询设备详情异常' + e)
      }
    },

  }
}
</script>

<style lang="scss">
.sb_marker {
  background-image: url("../../../static/img/common/u16.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  min-width: 200px;
  /*height: 57px;*/
  line-height: 20px;
  padding: 5px;

  .sb_marker_item {
    text-align: left;
    width: 100%;
    height: 25px;
    line-height: 25px;
  }
}

</style>



// WEBPACK FOOTER //
// src/studio/twoDMap/shebei_marker.vue